"use client";

import { LocationSelect } from "@/components/landing/LocationSelect";
import { cn } from "@/lib/utils";

const HERO_CONTROL_HEIGHT = "h-12";

const HERO_INPUT_OVERRIDES = "py-0 pl-11 pr-8 focus:ring-2 focus:ring-primary";

export interface HeroLocationSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export function HeroLocationSelect({
  value,
  onValueChange,
  className,
}: HeroLocationSelectProps) {
  return (
    <div className={cn(HERO_CONTROL_HEIGHT, "w-full min-h-0 flex", className)}>
      <LocationSelect
        value={value}
        onValueChange={onValueChange}
        triggerClassName={HERO_INPUT_OVERRIDES}
      />
    </div>
  );
}